/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        tag:'li',
        'class': ['product-item',nb.bind('style')],
        $html:{
            tag:'a',
            href:nb.bind('href'),
            target:'_blank',
            $html: [{
                'class': 'product-img abs-top-center',
                $html: {
                    tag: 'img',
                    alt:nb.bind('name'),
                    src: nb.bind('imgUrl')
                }
            }, {
                'class': 'product-hover abs-full',
                $html: [{
                    'class': 'cn-name uk-text-truncate',
                    $text:nb.bind('nameCn')  //name
                },{
                    'class': 'en-name uk-text-truncate',
                    $text:nb.bind('nameEn')
                },{
                    'class': 'product-price ',
                    $text:nb.bind('price')
                }]
            }]
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/product/ProductItem.js
// module id = 72
// module chunks = 5 6 17 31 33 34